var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"360","height":"360","viewBox":"0 0 360 360","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"1.8","y":"-1.8","width":"356.4","height":"356.4","rx":"22.2","transform":"matrix(1 0 0 -1 0 356.4)","stroke":"currentColor","stroke-opacity":"0.25","stroke-width":"3.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }